import React, { useState } from 'react'

import Sidebar from "../../components/Sidebar/index"
import Navbar from "../../components/Navbar/index"
import Section1 from "./Section1/index"
import Section2 from "./Section2/index"
import Section3 from "./Section3/index"
import Section4 from './Section4/index'
import Footer from "../../components/Footer/index"

import "../../assets/css/main.css"
import "./home.css"

const Home = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />
            <div className="home"><Section1 /></div>
            <div className='home'><Section2 /></div>
            <div className='mental'>
                <h1>Get Mental Clarity. </h1>
                <h1>Share your productivity.</h1>
                <h1>Don’t just save, get to it.</h1>
            </div>
            <div className='home'><Section3 /></div>
            <div className='home'><Section4 /></div>
            <Footer />
        </>
    )
}

export default Home;
